export const REQUEST_STATUSES = {
  FULFILLED: "fulfilled",
  REJECTED: "rejected",
};

export const PINCODE_MAP_MESSAGES = {
  SERVICEABLE_PINS_FAILED_SHOWING_NON_SERVICEABLE:
    "Serviceable pincodes failed to load. Showing non-serviceable data only.",
  NON_SERVICEABLE_PINS_FAILED: "Non-serviceable pincodes failed to load.",
  PINCODE_SERVICEABILITY_LOAD_FAILED: "Failed to load pincode serviceability data",
  HUB_LIST_LOAD_FAILED: "Failed to load hub listing",
};

export const PINCODE_MAP_FILTER_CARD_KEYS = {
  ALL: "all",
};

export const PINCODE_MAP_FILTER_PANEL_TEXT = {
  TITLE: "Serviceability Filters",
  RESET_BUTTON: "Reset to default",
};

export const PINCODE_MAP_STYLE_TOKENS = {
  STATS_SECTION_TITLE_MARGIN_BOTTOM: 0,
  STATS_PANEL_MARGIN: "20px 28px 0",
  STATS_PANEL_PADDING: "12px",
  STATS_HEAD_GAP: "10px",
  STATS_HEAD_MARGIN_BOTTOM: "10px",
  STATS_RESET_FONT_SIZE: "11px",
  STATS_RESET_HOVER_COLOR: "#1d4ed8",
  STATS_ROW_GAP: "12px",
  MOBILE_STATS_PANEL_MARGIN: "12px 16px 0",
  MOBILE_STATS_PANEL_PADDING: "10px",
  MOBILE_STATS_ROW_GAP: "8px",
};
